<template>
  <div>
    <div class="store-select__title">
      {{ $t('delivery-store-balance.store-select-title') }}
    </div>
    <vSelect
      class="select__select select__select--select store-select"
      :placeholder="$t('checkout_delivery_choice')"
      label="address"
      :options="availableStoresInCart"
      :value="selectedValue"
      @input="handleSelectStore"
      :clearable="false"
      :searchable="true"
      :filterable="true"
    >
      <span slot="no-options">{{ $t('not_found') }}</span>
      <template #option="option">
        <div>{{ option.address }}</div>
      </template>
    </vSelect>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'StoreSelect',
  components: { vSelect },
  props: {

  },
  computed: {
    ...mapGetters([
      'cartSort'
    ]),
    ...mapState({
      userStore: state => state.geoLocation.userStore,
      storesInCity: state => state.geoLocation.storesInCity
    }),
    selectedValue () {
      return this.userStore && this.availableStoresInCart.find(el => +el.id === +this.userStore.id)
    },
    availableStoresInCart () {
      // const storeIdsFromCart = new Set(
      //   this.cartSort.products.map(item => item.store_id)
      // )
      // return this.storesInCity.filter(store =>
      //   storeIdsFromCart.has(store.id)
      // )
      return this.storesInCity
    }
  },
  methods: {
    ...mapActions(['SET_STORE']),
    handleSelectStore (spot) {
      this.$emit('isLoading', true)
      this.SET_STORE({ storeId: spot.id, title: spot.address }).then(() => {
        this.$store.dispatch('GET_FULL_CART').then(() => {
          this.$emit('isLoading', false)
        })
      })
    }
  }
}
</script>

<style lang="sass">
.v-select.store-select .vs__actions:before
  display: none
</style>

<style lang="sass" scoped>
.store-select
  &__title
    margin-bottom: 5px
    font-size: 14px
    line-height: 21px
    color: #000
    +mmax(768)
      margin-top: 10px
</style>
